export interface NetworkInformationLike {
    saveData?: boolean;
    effectiveType?: string;
}

interface IssueWarmPlanOptions {
    neighborDepth?: number;
    recentCount?: number;
    maxItems?: number;
}

export function shouldWarmManyIssues(connection?: NetworkInformationLike | null): boolean {
    if (!connection) return true;
    if (connection.saveData) return false;

    const effectiveType = connection.effectiveType?.toLowerCase();
    return effectiveType !== 'slow-2g' && effectiveType !== '2g';
}

export function buildIssueWarmQueue(
    issueIds: string[],
    currentIndex: number,
    cachedIds: Iterable<string>,
    options: IssueWarmPlanOptions = {}
): string[] {
    const neighborDepth = options.neighborDepth ?? 2;
    const recentCount = options.recentCount ?? 12;
    const maxItems = options.maxItems ?? issueIds.length;
    const cached = new Set(cachedIds);
    const queued = new Set<string>();
    const queue: string[] = [];
    const centerIndex = Number.isInteger(currentIndex) && currentIndex >= 0
        ? Math.min(currentIndex, issueIds.length - 1)
        : 0;

    const addIndex = (index: number) => {
        if (queue.length >= maxItems) return;
        if (index < 0 || index >= issueIds.length) return;

        const issueId = issueIds[index];
        if (!issueId || cached.has(issueId) || queued.has(issueId)) return;

        queued.add(issueId);
        queue.push(issueId);
    };

    for (let distance = 1; distance <= neighborDepth; distance += 1) {
        addIndex(centerIndex + distance);
        addIndex(centerIndex - distance);
    }

    for (let index = 0; index < Math.min(recentCount, issueIds.length); index += 1) {
        addIndex(index);
    }

    for (let index = 0; index < issueIds.length; index += 1) {
        addIndex(index);
    }

    return queue;
}
